<template>
    <div id="toolbar" :style="{'background': color}">
        <div class="name">ShoppingCity Seiersberg</div>
        <div class="location">
            <div class="left">
                <img src="@/assets/pinwhite.svg" alt="">
                <span class="capitalise">{{languageStrings['haus']}}</span>  {{this.getHouse}}, <span class="capitalise">{{languageStrings['Ebene']}}</span> {{this.getLevel}}</div>
            <div class="right">
                <img src="@/assets/clockicon.svg" alt="">
                <span class="time">{{timestring}}</span>
            </div>
        </div>
        <div class="date">
            {{datestring}}
        </div>
        <div class="weather">
            <img :src="iconsrc" alt="">
            Seiersberg-Pirka, {{temp}}°C
        </div>
    </div>
</template>

<script>

import '../styles/variables.scss';
import axios from "axios";

export default {
    name: 'Toolbar',
    props: {
        color: String,
        options: Object,
        languageStrings: Object
    },
    data(){
        return {
            temp: 1,
            icon: '',
            datestring: '',
            timestring: ''
        }
    },
    computed: {
        iconsrc(){
            if (this.icon.length){
                return require('@/assets/weathericons/'+this.icon+'.svg');
            }
        },
        getHouse(){
            return this.options.location.substr(2,1)
        },
        getLevel(){
          if (this.options.location == 'tg5' || this.options.location == 'h17i' || this.options.location == 'h19b'){
            return '0';
          } else {
            return this.options.location.substr(1,1)
          }

        }
    },
    created() {
        let url = new URL(window.location.href)
        let disableweather = url.searchParams.get('disableweather');
        if ( !this.options.diableweather ){
            this.getWeather();
        }
        setInterval( this.getWeather, 300000 )
        this.setDate();
        setInterval( this.setDate, 60000 )

    },
    methods: {
        getWeather(){
            console.log('weather and time updated');
            var cityID = '2778067';
            var apiKey = 'a8486e550dcf3bcaf317ee43cef5fc62';
            axios.get('https://api.openweathermap.org/data/2.5/weather?id='+cityID+'&appid='+apiKey+'&units=metric').then(response => {
                // console.log (response.data)
                this.temp = ~~response.data.main.temp;
                if (response.data.weather[0].icon.substr(2,1) == 'n'){
                  this.icon = response.data.weather[0].icon.substr(0,2)+'d';
                } else {
                  this.icon = response.data.weather[0].icon;
                }

            }, error => {
                console.log('axios error in weather function' + error)
            });
        },
        setDate(){
            var now = new Date();
            var datestring = now.toLocaleDateString('de-DE', {weekday: 'short'}) + ', ' + now.toLocaleDateString('de-DE', {day: 'numeric'}) + '. ' + now.toLocaleDateString('de-DE', {month: 'long'});
            this.datestring = datestring;
            var mins = now.getMinutes();
            var timestring = now.getHours() + ':' + (mins > 9 ? mins : '0' + mins);
            this.timestring = timestring;
        },
    }
}
</script>

<style lang="scss">

@import "../styles/variables";

#toolbar {
    height: 80px;
    position: fixed;
    top: 0;
    width: 100%;
    color: white;
    display: flex;
    flex-direction: row;
    align-items: center;
    left: 0;
    font-weight: 700;
    font-size: 20px;
    z-index: 10;

    @include portrait(){
        transform: scale(1.4);
        transform-origin: top left;
    }

    &.blue {
        background: $blue;
    }

    > div {
        border-right: 3px solid white;
        height: 100%;
        display: flex;
        align-items: center;
        padding-left: 45px;
        padding-right: 45px;

        &:last-child {
            border-right: none;
        }
    }

    .name {
        width: 25%;
        font-size: 24px;
        @include portrait(){
            font-size: 20px;
        }
    }

    .time {
        @include fontSize(40,98);
    }

    .date {
        @include portrait(){
            display: none;
        }
    }

    .weather {
        @include portrait(){
            display: none;
        }
        img {
            margin-right: 20px;
        }
    }

    .location {
        flex-grow: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        img:first-of-type {
            position: relative;
            top: 4px;
            margin-right: 20px;
        }
        @include portrait(){
            flex-grow: 0;
            width: 528px;
            padding-left: 20px;
        }
    }
}
</style>
